import moment from 'moment';
import 'moment/locale/es-mx';
import { TICKET_STATUS_OPTIONS } from '../../../../../helpers/ticket-label-helper';

moment.locale('es-mx');

export const searchFieldOptions = [
    { value: 'code', label: 'Código' },
    { value: 'title', label: 'Título' },
    { value: 'priority', label: 'Prioridad' },
    { value: 'type', label: 'Tipo' },
    { value: 'status', label: 'Estatus' },
];

export const statusOptions = [{ value: 'ALL', label: 'Todos' }, ...TICKET_STATUS_OPTIONS];
export const STATUS_GROUP_PENDING = 'PENDING';
export const STATUS_GROUP_RESOLVED = 'RESOLVED';
export const STATUS_GROUP_OVERDUE = 'OVERDUE';

export const statusDotMap = {
    NEW: 'success',
    OPEN: 'primary',
    IN_PROGRESS: 'warning',
    PENDING_CUSTOMER: 'warning',
    PENDING_THIRD_PARTY: 'warning',
    RESOLVED: 'info',
    CLOSED: 'secondary',
    CANCELLED: 'danger',
};

export const statusInitialMap = {
    NEW: 'N',
    OPEN: 'O',
    IN_PROGRESS: 'P',
    PENDING_CUSTOMER: 'C',
    PENDING_THIRD_PARTY: 'T',
    RESOLVED: 'R',
    CLOSED: 'C',
    CANCELLED: 'X',
};

export const statusInitialClassMap = {
    NEW: 'ticket-status-initial--warning',
    OPEN: 'ticket-status-initial--danger',
    IN_PROGRESS: 'ticket-status-initial--primary',
    PENDING_CUSTOMER: 'ticket-status-initial--info',
    PENDING_THIRD_PARTY: 'ticket-status-initial--info',
    RESOLVED: 'ticket-status-initial--success',
    CLOSED: 'ticket-status-initial--secondary',
    CANCELLED: 'ticket-status-initial--danger',
};

export const priorityOrderMap = {
    LOW: 1,
    MEDIUM: 2,
    HIGH: 3,
    URGENT: 4,
    CRITICAL: 5,
};

export const priorityBadgeMap = {
    LOW: 'bg-soft-secondary text-secondary',
    MEDIUM: 'bg-soft-info text-info',
    HIGH: 'bg-soft-warning text-warning',
    URGENT: 'bg-soft-danger text-danger',
    CRITICAL: 'bg-dark text-white',
};

export const taskListTicketTypeIconMap = {
    INCIDENT: 'bi bi-exclamation-octagon',
    REQUEST: 'bi bi-life-preserver',
    PROBLEM: 'bi bi-bug',
    CHANGE: 'bi bi-arrow-repeat',
    TASK: 'bi bi-list-task',
};

const escapeHtml = (value = '') => {
    return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
};

export const textToHtml = (textValue = '') => {
    const clean = String(textValue || '').trim();
    if (!clean) return '';
    return `<p>${escapeHtml(clean).replace(/\n/g, '<br/>')}</p>`;
};

export const stripHtml = (value = '') => {
    const parsed = new DOMParser().parseFromString(String(value || ''), 'text/html');
    return String(parsed.body?.textContent || '').trim();
};

export const getDescriptionPreview = (ticket) => {
    const plainDescription = stripHtml(ticket?.description || '');
    if (!plainDescription) {
        return 'Sin descripción';
    }

    return plainDescription;
};

export const formatDueDate = (ticket) => {
    const dueDate = ticket?.resolutionDueDate || ticket?.firstResponseDueDate;
    if (!dueDate) {
        return '-';
    }

    return moment(dueDate).fromNow();
};

export const isTicketOverdue = (ticket) => {
    const status = String(ticket?.status || '');
    if (status === 'RESOLVED' || status === 'CLOSED' || status === 'CANCELLED') {
        return false;
    }

    const dueDate = ticket?.resolutionDueDate || ticket?.firstResponseDueDate;
    if (!dueDate) {
        return false;
    }

    const parsed = new Date(dueDate).getTime();
    return Number.isFinite(parsed) && parsed < Date.now();
};